import React, { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import './TemplateTooltip.scss';

/**
 * Renders a tooltip via a portal attached to document.body so it is never
 * clipped by overflow or stacking contexts on ancestor elements.
 *
 * Props:
 *   anchorRef  — ref attached to the card element used to calculate position
 *   visible    — boolean controlling visibility
 *   title      — template name (bold heading)
 *   description — template description text
 */
const TemplateTooltip = ({ anchorRef, visible, title, description }) => {
    const [pos, setPos] = useState({ top: 0, left: 0 });

    useLayoutEffect(() => {
        if (visible && anchorRef?.current) {
            const rect = anchorRef.current.getBoundingClientRect();
            setPos({
                top: rect.top + window.scrollY - 8,
                left: rect.left + window.scrollX + rect.width / 2,
            });
        }
    }, [visible, anchorRef]);

    if (!visible || (!title && !description)) return null;

    return createPortal(
        <div
            className="template-tooltip-portal"
            style={{ top: pos.top, left: pos.left }}
        >
            {title && <strong className="template-tooltip-title">{title}</strong>}
            {description && (
                <>
                    <br />
                    <br />
                    <span className="template-tooltip-description">{description}</span>
                </>
            )}
        </div>,
        document.body
    );
};

export default TemplateTooltip;
